<template>
  <v-container style="max-width:100vw;">
    <div style="background:white!important;" class="pa-4">
      <v-toolbar flat>
        <v-row class="ma-0 pt-6" align="center">
          <v-toolbar-title>
            Inventario por proveedor
          </v-toolbar-title>
          <v-spacer/>
          <v-text-field
            v-model="search"
            label="Buscar proveedor"
            prepend-icon="mdi-magnify"
            dense
            outlined
            rounded
            clearable
            style="max-width: 320px"
          />
        </v-row>
      </v-toolbar>

      <div>
        <v-data-table
          :headers="headers"
          :items="rows"
          :search="search"
          :loading="loading"
          class="mt-4"
          dense
        >
          <template v-slot:item.total_inventory_qty="{ item }">
            {{ number(item.total_inventory_qty) }}
          </template>
          <template v-slot:item.total_inventory_amount="{ item }">
            {{ money(item.total_inventory_amount) }}
          </template>

          <template v-slot:body.append>
            <tr style="font-weight:600;">
              <td>Totales</td>
              <td>{{ totals.items_count }}</td>
              <td>{{ number(totals.total_inventory_qty) }}</td>
              <td>{{ money(totals.total_inventory_amount) }}</td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </div>
  </v-container>
</template>

<script>
import axios from "axios"

export default {
  data() {
    return {
      loading: false,
      search: "",
      rows: [],
      headers: [
        { text: "Proveedor", value: "provider" },
        { text: "SKUs", value: "items_count" },
        { text: "Cantidad inventario", value: "total_inventory_qty" },
        { text: "Activo (Costo x Cantidad)", value: "total_inventory_amount" }
      ]
    }
  },

  computed: {
    filteredRows() {
      const q = (this.search || "").toLowerCase().trim()
      if (!q) return this.rows
      return this.rows.filter((r) => (r.provider || "").toLowerCase().includes(q))
    },
    totals() {
      return this.filteredRows.reduce((acc, row) => {
        acc.items_count += Number(row.items_count || 0)
        acc.total_inventory_qty += Number(row.total_inventory_qty || 0)
        acc.total_inventory_amount += Number(row.total_inventory_amount || 0)
        return acc
      }, {
        items_count: 0,
        total_inventory_qty: 0,
        total_inventory_amount: 0
      })
    }
  },

  created() {
    this.fetchReport()
  },

  methods: {
    money(value) {
      return new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(Number(value || 0))
    },
    number(value) {
      return new Intl.NumberFormat("es-MX", { maximumFractionDigits: 2 }).format(Number(value || 0))
    },
    async fetchReport() {
      this.loading = true
      try {
        const url = process.env.VUE_APP_BACKEND_ROUTE + "api/v2/reports/inventory-by-provider-cost"
        const { data } = await axios.get(url)
        this.rows = data?.data || []
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
